export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading font-bold text-background-50">
              吃瓜视频
            </span>
            <span className="block text-xs text-primary-400 mt-1">在线观看</span>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              汇聚51吃瓜在线、吃瓜在线等平台，吃瓜群众在线看热门八卦，瓜田每日更新，最新最全吃瓜内容一网打尽，满足在线吃瓜需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-medium text-background-100 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">吃瓜快讯</a>
              <a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精彩视频</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">吃瓜热榜</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-label font-medium text-background-100 mb-4">
              内容分类
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">专题合集</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">深度吃瓜</a>
              <a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">焦点专题</a>
              <a href="#features" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">平台特色</a>
              <a href="#comments" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">吃瓜热评</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-label font-medium text-background-100 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              暂未展示合作伙伴信息，敬请期待。
            </p>
            <div className="mt-5">
              <h4 className="text-sm font-label font-medium text-background-100 mb-3">
                关注我们
              </h4>
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                  <i className="ri-weibo-line"></i>
                </span>
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                  <i className="ri-wechat-line"></i>
                </span>
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                  <i className="ri-video-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 吃瓜视频在线观看 - 51吃瓜在线 版权所有
          </p>
          <p className="text-xs text-background-500">
            每日更新 · 放心吃瓜 · 安全浏览
          </p>
        </div>
      </div>
    </footer>
  );
}